import { useState } from "react"
import {
  useContractWrite,
  usePrepareContractWrite,
  useWaitForTransaction
} from "wagmi"
import SlicerContract from "@src/lib/artifacts/contracts/Slicer.sol/Slicer"
import { Button } from "@components/ui/base/button"
import { Input } from "@components/ui/base/input"
import { Label } from "@components/ui/label"

export const FEE_CHANGE_VIEW = (params: any) => {
  const { slicerId, slicerAddress, protocolFee } = params

  const [newProtocolFee, setNewProtocolFee] = useState(protocolFee)

  const { config } = usePrepareContractWrite({
    address: slicerAddress as `0x${string}`,
    abi: SlicerContract.abi,
    functionName: "_setCustomFee",
    args: [true, newProtocolFee]
  })
  const { data, isLoading, write } = useContractWrite(config)

  const { isSuccess, isLoading: isLoadingTransaction } = useWaitForTransaction({
    hash: data?.hash
  })

  return (
    <div className="sl-space-y-4">
      <div className="sl-pt-4 sl-pb-8 sl-text-center">
        <h1 className="sl-fonts">Change protocol fee</h1>
        <p className="sl-max-w-sm sl-pt-6 sl-mx-auto sl-text-gray-500">
          Slicer #{slicerId}
        </p>
      </div>
      <div className="sl-prose">
        <p>
          Slicer owners receive an amount of SLC tokens when they withdraw ETH
          or USDC, based on the protocol fee set.
        </p>
        {/* <p>
          Besides influencing the SLC tokens minted, a higher fee will result in a better
          positioning in our explore page and promotion of your slicer by Slice.
        </p> */}
        <p>
          As a superowner, you can set the fee for the slicer. Note that this
          affects all other owners as well.
        </p>
      </div>
      {!isSuccess ? (
        <>
          <div className="sl-py-4">
            <Label>Protocol fee</Label>
            <Input
              type="range"
              min={0}
              max={100}
              value={newProtocolFee}
              onChange={(e) => setNewProtocolFee(e.currentTarget.value)}
            />
          </div>
          <div className="sl-text-center">
            <Button
              className="sl-h-[38px] sl-font-bold sl-tracking-wide sl-rounded-md sl-overflow-hidden sl-px-5 sl-min-w-[180px] focus:sl-outline-none"
              onClick={async () => write()}
              loading={isLoading || isLoadingTransaction}
            >
              Set fee to {(Math.round(newProtocolFee) / 10).toFixed(1)}%
            </Button>
          </div>
        </>
      ) : (
        <div className="sl-pt-4 sl-text-center">
          <p className="sl-font-semibold sl-text-green-600">
            Custom fee set to {Math.round(newProtocolFee) / 10}%!
          </p>
          <p className="sl-pt-3 sl-text-muted-foreground">
            Reload the website to see it reflected in your slicers list
          </p>
        </div>
      )}
    </div>
  )
}

export default FEE_CHANGE_VIEW
